import React, { useEffect, useState } from "react";
import {
  Button,
  Form,
  Input,
  message,
  Modal,
  Space,
  Switch,
  Tag,
  Card,
  Popconfirm,
} from "antd";
import Table from "../../Reusable/Table/Table1";
import axios from "axios";
import consts from "../../constant";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import Loadingpage from "../Loadingpage/Loadingpage";

const TapTradesettings = () => {
  const [form] = Form.useForm();
  const [editForm] = Form.useForm();
  const [tapTrades, setTapTrades] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [messageApi, contextHolder] = message.useMessage();

  const fetchSettings = async () => {
    try {
      const { data } = await axios.post(`${consts.BackendUrl}/getTradeSettings`, { type: 'tapTrade' }, {
        headers: { Authorization: `Bearer ${window.localStorage.getItem("Jetix")}` }
      });
      if (data?.success && data?.result?.tapTrade) {
        setTapTrades(data?.result?.tapTrade);
      }
    } catch (error) {
      console.error("Error fetching settings:", error);
    }
  };

  useEffect(() => {
    fetchSettings();
  }, []);

  const onFinish = async (values) => {
    if (tapTrades.length >= 5) {
      return messageApi.open({ type: "error", content: "Maximum 5 tap trade settings allowed" });
    }
    setLoading(true);
    try {
      await axios.post(`${consts.BackendUrl}/tradeSettings`, {
        type: 'tapTrade',
        action: 'add',
        data: {
          lowMultiple: Number(values.lowmultiple),
          highMultiple: Number(values.highmultiple),
          duration: values.duration,
          verticalGrid: Number(values.verticalgrid),
          horizontalGrid: Number(values.horizontalgrid),
          isActive: values.isActive || false
        }
      }, {
        headers: { Authorization: `Bearer ${window.localStorage.getItem("Jetix")}` }
      });
      messageApi.open({ type: "success", content: "Tap trade setting added successfully" });
      form.resetFields();
      fetchSettings();
    } catch (error) {
      messageApi.open({
        type: "error",
        content: error.response?.data?.message || "Failed to add setting"
      });
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (record) => {
    setEditingId(record._id);
    editForm.setFieldsValue({
      lowmultiple: record.lowMultiple,
      highmultiple: record.highMultiple,
      duration: record.duration,
      verticalgrid: record.verticalGrid,
      horizontalgrid: record.horizontalGrid,
      isActive: record.isActive
    });
    setIsEditModalOpen(true);
  };

  const onEditFinish = async (values) => {
    setLoading(true);
    try {
      await axios.post(`${consts.BackendUrl}/tradeSettings`, {
        type: 'tapTrade',
        action: 'edit',
        id: editingId,
        data: {
          lowMultiple: Number(values.lowmultiple),
          highMultiple: Number(values.highmultiple),
          duration: values.duration,
          verticalGrid: Number(values.verticalgrid),
          horizontalGrid: Number(values.horizontalgrid),
          isActive: values.isActive
        }
      }, {
        headers: { Authorization: `Bearer ${window.localStorage.getItem("Jetix")}` }
      });
      messageApi.open({ type: "success", content: "Tap trade setting updated successfully" });
      setIsEditModalOpen(false);
      fetchSettings();
    } catch (error) {
      messageApi.open({
        type: "error",
        content: error.response?.data?.message || "Failed to update setting"
      });
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    try {
      await axios.post(`${consts.BackendUrl}/deleteTradeSettings`, {
        type: 'tapTrade',
        id
      }, {
        headers: { Authorization: `Bearer ${window.localStorage.getItem("Jetix")}` }
      });
      messageApi.open({ type: "success", content: "Tap trade setting deleted successfully" });
      fetchSettings();
    } catch (error) {
      messageApi.open({
        type: "error",
        content: error.response?.data?.message || "Failed to delete setting"
      });
    }
  };

  const userColumns = [
    { title: "Low Multiple", dataIndex: "lowMultiple", key: "lowMultiple" },
    { title: "High Multiple", dataIndex: "highMultiple", key: "highMultiple" },
    { title: "Duration", dataIndex: "duration", key: "duration" },
    { title: "Vertical Grid", dataIndex: "verticalGrid", key: "verticalGrid" },
    { title: "Horizontal Grid", dataIndex: "horizontalGrid", key: "horizontalGrid" },
    {
      title: "Status",
      dataIndex: "isActive",
      key: "isActive",
      render: (isActive) => isActive ? <Tag color="green">Active</Tag> : <Tag color="red">Inactive</Tag>
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          <Button icon={<EditOutlined />} onClick={() => handleEdit(record)} />
          <Popconfirm
            title={<span style={{ color: "white" }}>Delete the setting</span>}
            description={<span style={{ color: "white" }}>Are you sure you want to delete this setting?</span>}
            onConfirm={() => handleDelete(record._id)}
            okText="Yes"
            cancelText="No"
            overlayInnerStyle={{
              backgroundColor: "#03321E",
              border: "1px solid #2eff0c",
            }}
          >
            <Button
              icon={<DeleteOutlined />}
              danger
              disabled={record.isActive}
            />
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <>
      <Loadingpage />
      {contextHolder}
      <div
        className="display-2 p-10"
        style={{
          display: "flex",
          gap: "10px",
          alignItems: "center",
          flexWrap: "wrap",
        }}
      >
        <h2> TapTrade Settings</h2>
      </div>
      <div
        className="card-clr tab-trade-card"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",

        }}
      >
        <Card
          style={{
            width: "100%",
            maxWidth: 500,
            padding: "30px 20px",
            marginBottom: "50px",
          }}
        >
          <Form
            form={form}
            name="tap_basic"
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            labelAlign="left"
            style={{ maxWidth: 600 }}
            onFinish={onFinish}
            autoComplete="off"
          >
            <Form.Item
              label="Low Multiple"
              name="lowmultiple"
              rules={[{ required: true }]}
            >
              <Input
                placeholder="Low Multiple"
                onKeyPress={(e) => {
                  if (!/[0-9]/.test(e.key)) {
                    e.preventDefault();
                  }
                }}
              />
            </Form.Item>

            <Form.Item
              label="High Multiple"
              name="highmultiple"
              rules={[{ required: true }]}
            >
              <Input
                placeholder="High Multiple"
                style={{ width: "100%" }}
                onKeyPress={(e) => {
                  if (!/[0-9]/.test(e.key)) {
                    e.preventDefault();
                  }
                }}
              />
            </Form.Item>

            <Form.Item
              label="Duration"
              name="duration"
              rules={[{ required: true }]}
            >
              <Input
                placeholder="Duration"
                style={{ width: "100%" }}
                onKeyPress={(e) => {
                  if (!/[0-9]/.test(e.key)) {
                    e.preventDefault();
                  }
                }}
              />
            </Form.Item>

            <Form.Item
              label="Vertical Grid"
              name="verticalgrid"
              rules={[{ required: true }]}
            >
              <Input
                placeholder="Vertical Grid"
                style={{ width: "100%" }}
                onKeyPress={(e) => {
                  if (!/[0-9]/.test(e.key)) {
                    e.preventDefault();
                  }
                }}
              />
            </Form.Item>
            <Form.Item
              label="Horizontal Grid"
              name="horizontalgrid"
              rules={[{ required: true }]}
            >
              <Input
                placeholder="Horizontal Grid"
                style={{ width: "100%" }}
                onKeyPress={(e) => {
                  if (!/[0-9]/.test(e.key)) {
                    e.preventDefault();
                  }
                }}
              />
            </Form.Item>

            <Form.Item
              label="Is Active"
              name="isActive"
              valuePropName="checked"
            >
              <Switch />
            </Form.Item>

            <Form.Item style={{ display: "flex", justifyContent: "center" }}>
              <Button
                type={tapTrades.length >= 5 ? "default" : "primary"}
                danger={tapTrades.length >= 5}
                disabled={tapTrades.length >= 5}
                htmlType="submit"
                loading={loading}
                style={
                  tapTrades.length >= 5
                    ? {
                      backgroundColor: "#ff4d4f",
                      borderColor: "#ff4d4f",
                      color: "#fff",
                    }
                    : {}
                }
              >
                {tapTrades.length >= 5 ? "Limit Reached (5)" : "Add"}
              </Button>
            </Form.Item>
          </Form>
        </Card>
        {/* {tapTrades.length >= 5 && (
          <div style={{ textAlign: 'center', color: '#ff4d4f', marginTop: '10px' }}>
            5 items can only added
          </div>
        )} */}
      </div>

      <div className="taptrade-table">
        <Table
          columnsConfig={userColumns}
          data={tapTrades}
        // pagination={true}
        />
      </div>

      <Modal
        title="Edit Tap Trade Setting"
        open={isEditModalOpen}
        onCancel={() => setIsEditModalOpen(false)}
        footer={null}
        maskStyle={{
          backdropFilter: "blur(8px)",
          backgroundColor: "rgba(0, 0, 0, 0.2)",
        }}
        styles={{
          content: {
            backgroundColor: "rgba(255, 255, 255, 0.1)",
            backdropFilter: "blur(10px)",
            border: "1px solid rgba(255, 255, 255, 0.2)",
          },
          header: {
            backgroundColor: "transparent",
          },
        }}
      >
        <Form form={editForm} layout="vertical" onFinish={onEditFinish}>
          <Form.Item
            label="Low Multiple"
            name="lowmultiple"
            rules={[{ required: true }]}
          >
            <Input
              onKeyPress={(e) => {
                if (!/[0-9]/.test(e.key)) {
                  e.preventDefault();
                }
              }}
            />
          </Form.Item>

          <Form.Item
            label="High Multiple"
            name="highmultiple"
            rules={[{ required: true }]}
          >
            <Input
              onKeyPress={(e) => {
                if (!/[0-9]/.test(e.key)) {
                  e.preventDefault();
                }
              }}
            />
          </Form.Item>

          <Form.Item
            label="Duration"
            name="duration"
            rules={[{ required: true }]}
          >
            <Input
              onKeyPress={(e) => {
                if (!/[0-9]/.test(e.key)) {
                  e.preventDefault();
                }
              }}
            />
          </Form.Item>

          <Form.Item
            label="Vertical Grid"
            name="verticalgrid"
            rules={[{ required: true }]}
          >
            <Input
              onKeyPress={(e) => {
                if (!/[0-9]/.test(e.key)) {
                  e.preventDefault();
                }
              }}
            />
          </Form.Item>
          <Form.Item
            label="Horizontal Grid"
            name="horizontalgrid"
            rules={[{ required: true }]}
          >
            <Input
              onKeyPress={(e) => {
                if (!/[0-9]/.test(e.key)) {
                  e.preventDefault();
                }
              }}
            />
          </Form.Item>

          <Form.Item label="Is Active" name="isActive" valuePropName="checked">
            <Switch />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" loading={loading} block>
              Update
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default TapTradesettings;
